import ActivityLogForm from '../../components/consultants/ActivityLogForm'
import Auth from '../../auth.js'
import Hover from '../../components/Hover.vue';
import { createApp } from 'vue';
import { createPinia } from 'pinia'
// needed for tooltip integration

const pinia = createPinia();

if (document.getElementById('assessment-results-section-detail')) {
    const app = createApp({
        components: {
            ActivityLogForm,
            Hover
        },
        data() {
            return {
                hasMetClass: '#8ebb49',
                showLogForm: false,
                successMessages: []
            }
        },
        computed: {
            isProgramUser: function () {
                return Auth.is('program-user');
            }
        },
        methods: {
            handleSavedLog($evt) {
                this.successMessages.push('Sucessfully created activity log')
            }
        }
    });
    app.use(pinia);
    app.mount('#assessment-results-section-detail');
}

if (document.getElementById('assessment-results-summary-content')) {
    const app2 = createApp({
        components: {
            ActivityLogForm
        },
        data() {
            return {
                showLogForm: false,
                successMessages: []
            }
        },
        computed: {
            isProgramUser: function () {
                return Auth.is('program-user');
            }
        },
        methods: {
            handleSavedLog($evt) {
                this.successMessages.push('Sucessfully created activity log')
            }
        }
    });
    app2.use(pinia);
    app2.mount('#assessment-results-summary-content');
}